import React, { useEffect, useReducer } from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import * as oktaActions from "../../../actions/Okta";
import * as userActions from "../../../actions/User";
import Toaster from "../Toaster";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Link, useLocation } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import AssignmentLateOutlinedIcon from "@material-ui/icons/AssignmentLateOutlined";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import HistoryIcon from '@material-ui/icons/History';
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import QlpMenu from "../../Qlp/QlpMenu";
import DdPcrMenu from "../../ddPcr/ddPcrMenu";


import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import Tooltip from "@material-ui/core/Tooltip";

import { Helmet } from "react-helmet";
import TitleImage from "../../../images/logo-min.png";
import { parsePath, parsePageTitle } from "../../../utils/basic";
import ReactGA from "react-ga";
import MfgMenu from "../../ddPcr/MFG/MfgMenu";
import QCMenu from "../../QC/QCMenu";
import AutoDGMenu from "../../ddPcr/AutoDG/AutoDGMenu";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";
import EnvironmentBanner from "../EnvironmentBanner";
import VersionBanner from "../VersionBanner";


const drawerWidth = 180;

const styles = theme => ({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: "hidden",
        position: "relative",
        display: "flex"
    },
    appBar: {
        background: "#fff",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36
    },
    hide: {
        display: "none"
    },
    drawerPaper: {
        position: "relative",
        whiteSpace: "no-wrap",
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerPaperClose: {
        overflowX: "hidden",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(7)
        }
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 8px",
        ...theme.mixins.toolbar
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3)
    },
    primary: {},
    icon: {}
});

const initialState = {
    upgradeMessage: {},
    authenticated: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MESSAGE':
            return {
                ...state,
                upgradeMessage:
                    action.payload
                ,
                authenticated: true,
            }
        case 'AUTH_STATUS':
            return {
                ...state,
                upgradeMessage: {},
                authenticated: action.payload
            }

        default:
            return state
    }
}
const AppWrapper = (props) => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const location = useLocation();
    const { authState, oktaAuth } = useOktaAuth();

    useEffect(() => {

        // okta-react v6: authState is null until the auth service resolves.
        if (authState?.isAuthenticated) {
            dispatch({ type: 'AUTH_STATUS', payload: true })

            window.addEventListener("newContentAvailable", () => {
                const message = {
                    msg: "New features available. Please refresh your browser.",
                    key: Math.floor(Math.random() * 99999999999999999),
                    type: "success",
                    duration: 60000
                };
                dispatch({ type: "MESSAGE", payload: message })
            });
        }

        ReactGA.initialize("UA-145421575-1");
        ReactGA.pageview(window.location.pathname + window.location.search);


    }, [location, authState, oktaAuth]);

    const { classes,
        children,
        message,
        actions } = props;

    const rootDir = parsePath(location.pathname);
    const sampleListType =
        location.pathname && location.pathname.indexOf("rnd") !== -1 ? "rnd" : "clinical";

    const pageTitle = parsePageTitle(location.pathname);

    const nav = { active: "#00a650", inactive: "#a9a9a9" };
    const hasMfgQcAccess = useFeatureFlag("mfg-qc-access");

    const handleLogout = async () => {
        return oktaAuth.signOut();
    };

    let navAuth = (
        <div>
            <Tooltip
                id="home-icon"
                title={"Home"}
                placement="bottom"
            >
                <Link to="/">
                    <MenuItem
                        classes={{ selected: "selected" }}
                        selected={rootDir === "home" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <HomeOutlinedIcon
                                style={{
                                    color: rootDir === "home" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Home"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>
            <QlpMenu />
            <DdPcrMenu />
            {hasMfgQcAccess && <MfgMenu />}
            {hasMfgQcAccess && <AutoDGMenu />}
            {hasMfgQcAccess && <QCMenu />}

            {/* <Tooltip
                id="samples-icon"
                title={"Samples"}
                placement="bottom"
            >
                <Link to="/sample/rnd/list">
                    <MenuItem
                        classes={{ selected: "selected" }}
                        selected={rootDir === "sample" && sampleListType === "rnd" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <AssignmentOutlinedIcon
                                style={{
                                    color: rootDir === "sample" && sampleListType === "rnd" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="R&amp;D Samples"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>

            <Tooltip
                id="samples-icon"
                title={"Samples"}
                placement="bottom"
            >
                <Link to="/sample/clinical/list">
                    <MenuItem
                        classes={{ selected: "selected" }}
                        selected={
                            rootDir === "sample" && sampleListType === "clinical"
                                ? true
                                : false
                        }
                    >
                        <ListItemIcon className={classes.icon}>
                            <AssignmentLateOutlinedIcon
                                style={{
                                    color:
                                        rootDir === "sample" && sampleListType === "clinical"
                                            ? nav.active
                                            : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Clinical Trial Samples"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>

            <Tooltip
                id="patient-icon"
                title={"Patient"}
                placement="bottom"
            >
                <Link to="/patient/list">
                    <MenuItem
                        classes={{ selected: "selected" }}
                        selected={rootDir === "patient" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <AccountCircleIcon
                                style={{
                                    color: rootDir === "patient" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Patient"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>

            <Tooltip
                id="tags-icon"
                title="Tags"
                placement="bottom"
            >
                <Link to="/tag/list">
                    <MenuItem
                        classes={{ selected: "selected" }}
                        selected={rootDir === "tag" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <LabelOutlinedIcon
                                style={{
                                    color: rootDir === "tag" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Tags"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>

            <Tooltip
                id="tags-icon"
                title={"Vendors"}
                placement="bottom"
            >
                <Link to="/vendor/list">
                    <MenuItem
                        classes={{ selected: "selected" }}
                        selected={rootDir === "vendor" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <BusinessOutlinedIcon
                                style={{
                                    color: rootDir === "vendor" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Vendors"
                        />
                    </MenuItem>
                </Link>
            </Tooltip> */}

            <Tooltip
                id="profile-icon"
                title="Profile"
                placement="bottom"
            >
                <Link to="/profile">
                    <MenuItem
                        className={classes.menuItem}
                        selected={rootDir === "profile" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <PersonOutlineIcon
                                style={{
                                    color: rootDir === "profile" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Profile"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>

            <Tooltip
                id="help-icon"
                title="Help"
                placement="bottom"
            >
                <Link to="/help">
                    <MenuItem
                        className={classes.menuItem}
                        selected={rootDir === "help" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <HelpOutlineOutlinedIcon
                                style={{
                                    color: rootDir === "help" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Help"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>

            <Tooltip
                id="changeLog-icon"
                title="Change Log"
                placement="bottom"
            >
                <Link to="/changeLog">
                    <MenuItem
                        className={classes.menuItem}
                        selected={rootDir === "changeLog" ? true : false}
                    >
                        <ListItemIcon className={classes.icon}>
                            <HistoryIcon
                                style={{
                                    color: rootDir === "changeLog" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{
                                primary: classes.primary
                            }}
                            primary="Change Log"
                        />
                    </MenuItem>
                </Link>
            </Tooltip>



            <Tooltip
                id="logout-icon"
                title={"Logout"}
                placement="bottom"
            >
                <MenuItem className={classes.menuItem} onClick={handleLogout}>
                    <ListItemIcon className={classes.icon}>
                        <ExitToAppOutlinedIcon
                            style={{
                                color: "#a9a9a9"
                            }}
                        />
                    </ListItemIcon>
                    <ListItemText
                        classes={{
                            primary: classes.primary
                        }}
                        primary="Logout"
                    />
                </MenuItem>
            </Tooltip>
        </div>
    );

    let navNotAuth = (
        <div>
            <Link to="/">
                <MenuItem
                    selected={rootDir === "home" ? true : false}
                    className={classes.menuItem}
                >
                    <Tooltip id="home-icon" title="Home">
                        <ListItemIcon className={classes.icon}>
                            <HomeOutlinedIcon
                                style={{
                                    color: rootDir === "home" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                        classes={{
                            primary: classes.primary
                        }}
                        primary="Home"
                    />
                </MenuItem>
            </Link>
            <Link to="/login">
                <MenuItem
                    selected={rootDir === "login" ? true : false}
                    className={classes.menuItem}
                >
                    <Tooltip id="login-icon" title="Login">
                        <ListItemIcon className={classes.icon}>
                            <PersonOutlineIcon
                                style={{
                                    color: rootDir === "login" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                        classes={{
                            primary: classes.primary
                        }}
                        primary="Login"
                    />
                </MenuItem>
            </Link>
            <Link to="/register">
                <MenuItem
                    selected={rootDir === "register" ? true : false}
                    className={classes.menuItem}
                >
                    <Tooltip id="login-icon" title="New User">
                        <ListItemIcon className={classes.icon}>
                            <PersonOutlineIcon
                                style={{
                                    color: rootDir === "register" ? nav.active : nav.inactive
                                }}
                            />
                        </ListItemIcon>
                    </Tooltip>
                    <ListItemText
                        classes={{
                            primary: classes.primary
                        }}
                        primary="New User"
                    />
                </MenuItem>
            </Link>
        </div>
    );

    const navLinks = state.authenticated ? navAuth : navNotAuth;

    return (
        <div className="onetToolContainer flex">
            <AppBar
                position="fixed"
                color="primary"
                id="app-bar"
                className={classNames(
                    classes.appBar
                )}
            >
                <Toolbar>
                    <img className="logo" alt="" src={TitleImage} />
                    {/* <Typography variant="h5" id="nav-bar-title" color="text-custom-green">
                        One Tool
                    </Typography> */}

                    <h3 className="text-custom-green">One Tool</h3>

                    {/* <div className="flex-grow"></div>
                    <a href="/login" className="text-custom-green">
                        <h3>Login</h3>
                    </a>
                    <span className="p-5 text-custom-green"> | </span>
                    <a href="/register" className="text-custom-green">

                        <h3>New User</h3>
                    </a> */}

                    <div className="flex-grow flex justify-center">
                        <EnvironmentBanner />
                    </div>
                    <VersionBanner />

                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                id="nav-bar"
                classes={{
                    paper: classNames(
                        classes.drawerPaper,
                        classes.drawerPaperClose
                    )
                }}
            >
                <div className={classes.toolbar}>
                </div>
                <Divider />
                <MenuList>{navLinks}</MenuList>
                <Divider />
            </Drawer>
            <main className={classes.content}>
                <div className={classes.toolbar} /> {children}
            </main>

            {message && message.key && (
                <Toaster
                    text={message.text}
                    autoHideDuration={message.duration || 3000}
                    type={message.msgType}
                    key={message.key}
                    actions={actions}
                />
            )}
            {state.upgradeMessage && state.upgradeMessage.key && (
                <Toaster
                    text={state.upgradeMessage.text}
                    autoHideDuration={state.upgradeMessage.duration}
                    type={state.upgradeMessage.msgType}
                    key={state.upgradeMessage.key}
                />
            )}

            <Helmet>
                <title className="text-custom-green">One Tool | {pageTitle}</title>
            </Helmet>
        </div>
    );

}


AppWrapper.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired
};

const stateToProps = state => ({
    login: state.login,
    message: (state.user && state.user.message) || {},
    serviceWorker: state.serviceWorker
});

const dispatchToProps = dispatch => ({
    actions: bindActionCreators(
        Object.assign({}, oktaActions, userActions),
        dispatch
    )
});



export default compose(connect(stateToProps, dispatchToProps), withStyles(styles, { withTheme: true }))(AppWrapper);
